export const MULTI_SELECT = {
  VISIBLE_SELECTED_COUNT: 2,
  DAY_OF_WEEK_OPTIONS_COUNT: 3,
  CUSTOM_ROUTINE_DAYS_OF_WEEK_VISIBLE_SELECTED_COUNT: 5,
  CONFIRM_FOOTER_HEIGHT_PX: 48,
  CONFIRM_DROPDOWN_MIN_WIDTH_PX: 240,
  ROUTINE_SUGGESTIONS_REVAMP_DAYS_OF_WEEK_VISIBLE_SELECTED_COUNT: 5
};

export const MULTI_SELECT_QUICK_ACTION_ID = {
  WEEKDAYS: 'weekdays',
  WEEKEND: 'weekend'
} as const;
